export enum Actions {
  SET_HAS_NEW_VERSION = "SET_HAS_NEW_VERSION",
  DISMISS = "DISMISS",
  SET_VERSION = "SET_VERSION",
  SET_FIRST_TIME_LOADING = "SET_FIRST_TIME_LOADING",
  SET_INITIAL_VERSION = "SET_INITIAL_VERSION",
}

export type Action =
  | { type: Actions.DISMISS }
  | { type: Actions.SET_HAS_NEW_VERSION; payload: boolean }
  | { type: Actions.SET_VERSION; payload: { version: string } }
  | { type: Actions.SET_FIRST_TIME_LOADING; payload: boolean }
  | {
      type: Actions.SET_INITIAL_VERSION;
      payload: { version: string };
    };
